import { deckCover, deckHueKey, pictureSrc, textFit, type CardFace, type Deck, type MaterialAsset } from '@aurora/core'

/** The deck's hue as a CSS colour, from the shared pick in core. */
export function deckHue(id: string | undefined): string {
  return `var(--domain-${deckHueKey(id)})`
}

/** The deck's cover: its clay picture, its emoji, its few characters, or its first letter, on its hue. */
export function DeckCover({ deck, title, size = 48 }: { deck: Deck | null; title?: string; size?: number }) {
  const { picture, emoji, text } = deckCover(deck)
  const name = deck?.title ?? title ?? ''
  return (
    <span
      className="deck-cover"
      style={{ '--deck-hue': deckHue(deck?.id ?? name), width: size, height: size } as React.CSSProperties}
      aria-hidden="true"
    >
      {picture ? (
        <img src={picture} alt="" />
      ) : emoji ? (
        <span className="deck-cover-emoji">{emoji}</span>
      ) : (
        <span className={`deck-cover-letter${text && text.length > 1 ? ' is-short' : ''}`}>{text ?? name.slice(0, 1)}</span>
      )}
    </span>
  )
}

/**
 * A card's front, small: its text, else its picture (a bank word, or one
 * made for the deck, found among the deck's ready assets), else its emoji.
 */
export function CardFaceMini({ face, assets }: { face: CardFace | undefined; assets?: MaterialAsset[] }) {
  const made = assets?.find((a) => a.id === face?.picture && a.status === 'ready' && a.url)
  const src = pictureSrc(face?.picture) ?? made?.url
  const text = face?.text ?? (src || face?.emoji ? undefined : face?.say ?? '?')
  if (text) return <span className={`face-mini-text${text.length > 3 ? ' is-long' : ''}`} style={{ '--fit': textFit(text) } as React.CSSProperties}>{text}</span>
  if (src) return <img className="face-mini-pic" src={src} alt="" />
  return <span className="face-mini-emoji">{face?.emoji}</span>
}

